export default function() {
    jQuery('.js-accordion--toggle').on('click', function() {
        jQuery(this).toggleClass('active');
        jQuery(this).next('.js-accordion--content').slideToggle(300);
    });
}